import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../services/utility.service';
import { IState } from '../models/state';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'pq-register',
  templateUrl: './register.component.html',
  standalone: false,
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup = this.fb.group({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    company: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl(''),
    dealerTypeId: new FormControl(''),
  });

  submitted: boolean = false;
  statesList!: IState[];

  capsOn: any;
  captchaKey: string = environment.captchaKey;
  captchaIsValid: boolean = false;

  get email() {
    return this.registerForm.get('email');
  }

  get registerFormGroup() {
    return this.registerForm;
  }

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    public readonly router: Router,
    private readonly messageService: MessageService,
    private readonly utilityService: UtilityService,
  ) {
    this.registerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      company: ['', Validators.required],
      city: ['', Validators.required],
      stateId: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      dealerTypeId: [environment.dealerTypeId, Validators.required],
    });

    this.statesList = utilityService.statesList;
  }

  ngOnInit(): void {}

  getCaptchaValue(captcha: string | null) {
    this.captchaIsValid = !(captcha === null || captcha === undefined);
  }

  isControlInvalid(controlName: string): boolean {
    const formControl = this.registerForm.get(controlName);
    return (
      (formControl?.invalid && (formControl?.touched || this.submitted)) ||
      false
    );
  }

  register() {
    this.submitted = true;
    if (!this.captchaIsValid) {
      return;
    }
    if (this.registerForm.invalid) {
      return;
    }

    this.authService.register(this.registerForm.value).subscribe(
      (data) => {
        const message = {
          severity: 'success',
          summary: 'Registration was successful',
          life: 10000,
          key: 'success',
          detail:
            'Check your email to set up your password and multi-factor authentication.',
        };
        this.messageService.add(message);
      },
      (error) => {
        const errors = Array.isArray(error.error) ? error.error : [error.error];

        for (const data of errors) {
          const message = {
            severity: 'error',
            summary: data?.code || data?.Code || 'Error',
            key: 'error',
            life: 10000,
            detail:
              data?.description ||
              data?.Description ||
              data?.message ||
              data?.error ||
              'Registration failed. Please try again.',
          };
          this.messageService.add(message);
        }
      },
    );
  }
}
